















import {
  DisplayModule,
  MainModule,
  DocumentsModule,
} from '@/store/store.helper';
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as enums from '@/types/enums'

@Component({})
export default class aboutDocument extends Vue {
  @DocumentsModule.DocumentsGetter private documentTitle;
  @DocumentsModule.DocumentsGetter private documentId;
  @DocumentsModule.DocumentsGetter private documentAbout;

  @DisplayModule.DisplayMutation public setNavBar;
  @DisplayModule.DisplayGetter private getColor;

  private async created() {
    this.setNavBar({
      title: `אודות המסמך`,
      icon: 'close',
      color: this.getColor(enums.SECTION_STATUS.inTheVote),
    });
  }
}
